import React from "react";

const ExpandIcon = ({ fill = "black" }) => {
  return (
    // <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    //   <g opacity="1" clipPath="url(#clip0_3861_29559)">
    //     <path
    //       d="M7.02889 14H5.03064V19H10.0263V17H7.02889V14ZM5.03064 10H7.02889V7H10.0263V5H5.03064V10ZM17.0201 17H14.0228V19H19.0184V14H17.0201V17ZM14.0228 5V7H17.0201V10H19.0184V5H14.0228Z"
    //       fill={fill}
    //     />
    //   </g>
    //   <defs>
    //     <clipPath id="clip0_3861_29559">
    //       <rect width="23.979" height="24" fill="white" transform="translate(0.0350342)" />
    //     </clipPath>
    //   </defs>
    // </svg>
    <i className="expandicon"/>
  );
};

export default ExpandIcon;
